import React from 'react';
import _ from 'lodash';

import FilterItem from "./FilterItem";
import gridFilterSlice from "../../../ReduxStore/GroupGrid/gridFilterSlice";

import {useDispatch} from "react-redux";
import FilterWidgetHeadline from "./FilterWidgetHeadline";
import FilterWidgetContent from "../sidebar/FilterWidgetContent";
import {useClassList} from "../../../Utility/siteConfig";
import {sortListByNumberForwardText, splitNumberForwardText} from "../../../Utility/numbers";

// 2023-11 MH modernised
export default function FilterWidget({
  gridId,
  filter,
  disabledOptions = [],
  // options, buckets, selections are the hashes for THIS FILTER ONLY
  options = {},
  selections = {},
  filtersTouched,
  filterMap,
  buckets={}
}) {
  const dispatch = useDispatch();
  const className = useClassList({
    key: 'FilterWidget', fallback: 'mb-4'
  })

  const filterName = filter.name;

  const optionList = sortListByNumberForwardText(_.values(options), opt => opt.name);

  const {displayMode = 'open'} = filter;
  const isOpen = (displayMode === 'open');
  const disabledMap = _.keyBy(disabledOptions);
  // let disabledCount = _.size(disabledMap);

  // toggle this filter widget open/closed
  const handleToggleOpen = evt => {
    dispatch(gridFilterSlice.actions.toggleOpenClosed({
      gridId,
      filterName
    }));
  }

  return (
    <div className={className} id={`${filterName}-filter`}>
      <FilterWidgetHeadline
        gridId={gridId}
        filterName={filterName}
        headline={filter.displayName || _.capitalize(filterName)}
        handleToggleOpen={handleToggleOpen}
        isOpen={isOpen}
      />

      <FilterWidgetContent isOpen={isOpen}>
        {optionList.map(option => {
          const disabled = disabledMap[option.id];

          if (disabled) return null;

          return <FilterItem
            gridId={gridId}
            key={option.id}
            filter={filter}
            filterOption={option}
            disabled={disabled}
            selected={!!(selections["" + option.id])}
            filtersTouched={filtersTouched}
            buckets={buckets}
          />
        })}
      </FilterWidgetContent>

    </div>
  )
}

